import React from 'react';

import { showName } from './helpers';
import styles from './index.module.scss';

const DepositInfo = ({ deposit }) => {
  return (
    <div className={styles.info}>
      <div className={styles.item}>
        <p className={styles.title}>編號</p>
        <p className={styles.content}>{deposit.plateNumber}</p>
      </div>
      <div className={styles.item}>
        <p className={styles.title}>姓名</p>
        <p className={styles.content}>{showName(deposit)}</p>
      </div>
      <div className={styles.item}>
        <p className={styles.title}>物品名稱</p>
        <p className={styles.content}>{deposit.itemName}</p>
      </div>
    </div>
  );
};

export default DepositInfo;
